import { jsx as _jsx } from "react/jsx-runtime";
import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect, useState } from 'react';
import { Span } from 'shared';
import { useGetServicingV1BankNameLookupQuery } from 'servicing-api';
import { ROUTING_NUMBER_PATTERN } from '../constants';
const LOOKUP_DEBOUNCE_MS = 400;
/**
 * Shows the bank behind a routing number once nine digits have been typed.
 *
 * A routing number we cannot resolve renders nothing rather than an error — the
 * customer is allowed to continue on one, and the add endpoint has the final say.
 */
function BankNameLookup({ routingNumber = '' }) {
    const [debouncedRoutingNumber, setDebouncedRoutingNumber] = useState(routingNumber);
    useEffect(() => {
        const timeout = setTimeout(() => setDebouncedRoutingNumber(routingNumber), LOOKUP_DEBOUNCE_MS);
        return () => clearTimeout(timeout);
    }, [routingNumber]);
    const { currentData: bank } = useGetServicingV1BankNameLookupQuery(ROUTING_NUMBER_PATTERN.test(debouncedRoutingNumber)
        ? { routingNumber: debouncedRoutingNumber }
        : skipToken);
    const hasSettled = debouncedRoutingNumber === routingNumber;
    const bankName = hasSettled ? bank?.name : undefined;
    if (!bankName)
        return null;
    return (_jsx(Span, { variant: "body-small", className: "bank-name-lookup", children: bankName }));
}
export default BankNameLookup;
